import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import "./task-created-standard.scss";

const TaskCreatedStandard = ({ show, onHide, isSubtask, labels }) => {
  let history = useHistory();
  const [showModal, setShowModal] = useState(show ?? false);

  return (
    <Modal show={showModal} onHide={onHide} className="task-created-standard">
      <Modal.Body className="task-edited-popup">
        <div className="icon-confirm"></div>
        {isSubtask ? (
          <h3 className="text-confirm">
            The subtask has been created successfully.
          </h3>
        ) : (
          <h3 className="text-confirm">
            The {labels?.TaskSingular ?? 'task'} has been created successfully.
          </h3>
        )}
        <div className="button-row">
          <Button
            onClick={(e) => {
              onHide(e);
            }}
            className="btn-large"
          >
            Create New {labels?.TaskSingular ?? 'Standard Task'}
          </Button>

          <Button
            className="btn-large btn-outlined "
            onClick={() => {
              history.push("/tasks");
            }}
          >
            Go to {labels?.TaskPlural ?? 'Task'} List
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TaskCreatedStandard;
